import * as React from 'react';
import { ComponentProps, ValidationSummary, ValidationProps } from 'ui';

export interface ColumnsPanelProps extends ComponentProps {
  /** 
   * The flexbox column size (1-12)
   */
  columns: number;
  children: any;
  validation?: ValidationProps;
}

export const ColumnsPanel: React.FC<ColumnsPanelProps> = (props: ColumnsPanelProps) => {

  const {
    componentId,
    children,
    columns='auto',
    validation,
    className
  } = props;

  if( (typeof columns === 'number') && (columns < 1 || columns > 12)){
    throw new Error('configured columns must be between 1 and 12 for ColumnsPanel');
  }

  return (
    <div id={componentId}  className={`col-lg-${columns} ${className}`}>
      <ValidationSummary validationError={validation}/>
      {children}                  
    </div>            
  );
};
